import actionTypes from "_constants/actionTypes";

export const authActions = {
  login,
  endTransaction,
  forgotPassword,
  resetPassword,
  logout,
  getUserToken,
  register,
  checkCode,
  actualYear,
};
function endTransaction() {
  return {
    type: actionTypes.END_TRANSACTION,
  };
}

function actualYear() {
  return {
    type: actionTypes.GET_ACTUAL_YEAR,
    payload: "",
  };
}

function checkCode(payload) {
  return {
    type: actionTypes.CHECK_CODE,
    payload: payload,
  };
}

function register(payload) {
  return {
    type: actionTypes.REGISTER_USER,
    payload: payload,
  };
}

function getUserToken(token) {
  return {
    type: actionTypes.GET_USER,
    token: token,
  };
}
function login(email, password, remember, access) {
  const payload = {email, password, remember, access};
  return {
    type: actionTypes.LOGIN_USER,
    payload,
  };
}
function forgotPassword(email) {
  const payload = {email};
  return {
    type: actionTypes.FORGOTPASSWORD,
    payload,
  };
}
function resetPassword(email, password, reppassword) {
  const payload = {email, password, reppassword};

  return {
    type: actionTypes.RESETPASSWORD,
    payload,
  };
}
function logout() {
  return {
    type: actionTypes.LOGOUT,
    payload: "",
  };
}
